const i18n = require("@/i18n");

module.exports = {
  id: "Stylable_StylableButton_25",
  preset: { rect: { width: 112, height: 71, x: 0, y: 745 }, tags: null },
  structure: {
    parent: "comp-knzvqsjj",
    style: {
      styleType: "custom",
      componentClassName: "wixui.StylableButton",
      style: {
        groups: {},
        properties: {
          "$st-css":
            ':import{\n    -st-from: \'wix-ui-santa/index.st.css\';\n    -st-named: StylableButton\n}\n.root{\n    -st-extends: StylableButton;\n    transition: all 0.2s ease, visibility 0s;\n    background: rgba(34,31,123,0);\n    border: 0px solid rgb(71, 67, 197)\n}\n.root:hover{\n    border: 0px solid value(site_1_5);\n    border-bottom: 0px solid value(site_1_5);\n    background: rgba(255,255,255,0)\n}\n.root:disabled{\n    background: rgba(226,226,226,0)\n}\n.root:disabled::label{\n    color: #8F8F8F\n}\n.root:disabled::icon{\n    fill: #8F8F8F\n}\n.root::container{\n    transition: inherit\n}\n.root::label{\n    transition: inherit;\n    font-weight: normal;\n    font-style: normal;\n    letter-spacing: 0em;\n    color: #221F7B;\n    font-family: "arial black",arial-w01-black,arial-w02-black,"arial-w10 black",sans-serif;\n    font-size: 18px\n}\n.root::icon{\n    transition: inherit;\n    width: 10px;\n    height: 10px;\n    fill: value(site_1_1);\n    display: none\n}\n.root:hover::icon{\n    fill: value(site_1_5)\n}\n.root:hover::label {\n    text-decoration-line: underline;\n}',
        },
        propertiesSource: { "$st-css": "value" },
      },
      pageId: "",
      compId: "",
      type: "ComponentStyle",
      metaData: {
        isHidden: false,
        sig: "4ie-197",
        pageId: "c1dmp",
        schemaVersion: "1.0",
        isPreset: false,
      },
      skin: "wixui.skins.Skinless",
    },
    activeModes: {},
    data: {
      type: "StylableButton",
      metaData: {
        isHidden: false,
        sig: "hmj-1067",
        pageId: "c1dmp",
        schemaVersion: "1.0",
        isPreset: false,
      },
      label: i18n.translate("buttons_text_preset_explore"),
      svgId: "b861b040274141de9c08999ec3b76edf.svg",
    },
    components: [],
    componentType: "wixui.StylableButton",
    id: "comp-kmdenk69",
    layout: {
      x: 10,
      fixedPosition: false,
      y: 759,
      scale: 1,
      height: 40,
      rotationInDegrees: 0,
      width: 95,
    },
    type: "Component",
    props: {
      type: "StylableButtonProperties",
      metaData: { schemaVersion: "1.0", sig: "hmj-1050", pageId: "c1dmp" },
    },
    metaData: { sig: "inq-337", pageId: "c1dmp" },
    skin: "wixui.skins.Skinless",
  },
};
